import React, { useMemo } from 'react';

import sum from 'lodash/sum';

import { Section, Grid } from '@gogame/components';
import { withForm, SidePageV2 } from '@gogame/form';
import { useCurrencyFormat } from '@gogame/intl-ts';

import ApplicationSpend from './components/ApplicationSpend';
import MonthPickerField from './components/MonthPickerField';
import { PERIOD, APPLICATION_SPEND, APPLICATION, SPEND } from './constants';
import { mainBudgetPlanningSchema } from './schemas';

const MainBudgetPlanningForm = withForm({
  enableReinitialize: true,
  validationSchema: mainBudgetPlanningSchema,
})(({ title, subTitle, values, onClose, loading, onExited, open, isEdit }) => {
  const { [APPLICATION_SPEND]: applicationSpend = [] } = values;

  const currencyFormatter = useCurrencyFormat();

  const totalBudgetSum = useMemo(
    () =>
      currencyFormatter(
        Number(
          sum(applicationSpend.map(({ [SPEND]: spend }) => spend))?.toFixed(2)
        ) || 0
      ),
    [applicationSpend]
  );

  const addDisabled = useMemo(
    () => !applicationSpend[applicationSpend.length - 1]?.[APPLICATION],
    [applicationSpend]
  );

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
    >
      <React.Fragment>
        <SidePageV2.Title title={title} subTitle={subTitle} />
        <SidePageV2.NewBody>
          <Section title={'General'}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <MonthPickerField
                  label={'Period'}
                  name={PERIOD}
                  disabled={isEdit}
                  required={true}
                  padding={0}
                />
              </Grid>
            </Grid>
          </Section>
          <Section title={'Budget'} subTitle={`Total Spend: ${totalBudgetSum}`}>
            <ApplicationSpend
              name={APPLICATION_SPEND}
              addDisabled={addDisabled}
            />
          </Section>
        </SidePageV2.NewBody>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
      </React.Fragment>
    </SidePageV2>
  );
});

export default MainBudgetPlanningForm;
